// extracted by mini-css-extract-plugin
export default {"abteilungDiv":"teamLinks_abteilungDiv__lIbup","abteilungen":"teamLinks_abteilungen__iueLl","abteilungenSeniorinnen":"teamLinks_abteilungenSeniorinnen__eegwl"};